
import React from "react";
import { useTranslation } from "react-i18next";

type TestType = "all" | "putting" | "chipping" | "wedging" | "bunker" | "iron" | "fairwayWood" | "driver";

// Get route based on test type
export const getTestRoute = (testType: string, testId: string) => {
  if (testType === "level3") {
    return `/training/level3?test=${testId}`;
  } else if (testType === "level2") {
    return `/training/level2?test=${testId}`;
  } else if (testType === "level1") {
    return `/training/level1?test=${testId}`;
  } else {
    return `/training/${testType}`;
  }
};

// Fonction pour obtenir le nom du niveau
export const getLevelName = (testType: string) => {
  const { t } = useTranslation('dashboard');
  
  switch (testType) {
    case "level1":
      return t('levels.level1');
    case "level2":
      return t('levels.level2');
    case "level3":
      return t('levels.level3');
    default:
      return testType;
  }
};

// Fonction pour obtenir la couleur du badge selon le niveau
export const getLevelBadgeVariant = (testType: string): "secondary" | "default" | "outline" => {
  switch (testType) {
    case "level1":
      return "secondary";
    case "level2":
      return "default";
    case "level3":
      return "outline";
    default:
      return "secondary";
  }
};

// Fonction pour déterminer le type d'exercice basé sur l'ID du test
export const getTestCategory = (testId: string): TestType => {
  if (testId.includes("bunker")) return "bunker";
  if (testId.includes("iron")) return "iron";
  if (testId.includes("fairwayWood")) return "fairwayWood";
  if (testId.includes("driver")) return "driver";
  if (testId.includes("putts")) return "putting";
  if (testId.includes("chipping")) return "chipping";
  if (testId.includes("wedging")) return "wedging";
  return "all";
};

// Fonction pour obtenir l'icône appropriée en fonction du test
export const getTestIcon = (testId: string): React.ReactNode => {
  if (testId.includes("putts")) {
    return React.createElement("span", { className: "text-2xl" }, "🎯");
  } else {
    return React.createElement("span", { className: "text-2xl" }, "⛳");
  }
};
